import { render, staticRenderFns } from "./ImageAiDlg.vue?vue&type=template&id=6c08affb&scoped=true&"
import script from "./ImageAiDlg.vue?vue&type=script&lang=ts&"
export * from "./ImageAiDlg.vue?vue&type=script&lang=ts&"
import style0 from "./ImageAiDlg.vue?vue&type=style&index=0&id=6c08affb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c08affb",
  null
  
)

export default component.exports